<!--销售报价单打印模板-->
<template>
    <div v-loading="loading" style="min-height: 400px">
        <div id="printContent">
            <div v-for="(item, index) in printList" :key="index">
                <div v-if="isEditTitle" class="print-title">
                    <el-input type="text" v-model="titleConfig.RValue" style="width: 200px"></el-input>
                </div>
                <div v-else class="print-title">{{ orderData.IsHaveTitleSet ? orderData.OrderTitle : titleConfig.RValue }}</div>
                <div class="order-detail">
                    <div>{{ item.NeedTime ? '期限日期：' + item.NeedTime : '' }}</div>
                    <div>
                        开单日期：
                        <el-date-picker v-show="openTimeEdit" v-model="item.QTime" value-format="yyyy-MM-dd" type="date" size="small" placeholder="选择日期时间"></el-date-picker>
                        <span v-show="!openTimeEdit">{{ item.QTime }}</span>
                    </div>
                </div>
                <div class="print-table-main">
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 16%">客户名称</div>
                        <div class="div-table-cell" style="width: 84%">{{ item.EntpCusName }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 16%">联系电话</div>
                        <div class="div-table-cell" style="width: 84%"></div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 16%">汽配编码</div>
                        <div class="div-table-cell" style="width: 18%">配件名称</div>
                        <div class="div-table-cell" style="width: 20%">车型</div>
                        <div class="div-table-cell" style="width: 6%">数量</div>
                        <div class="div-table-cell" style="width: 6%">单位</div>
                        <div class="div-table-cell" style="width: 9%">销售单价</div>
                        <div class="div-table-cell" style="width: 9%">销售总价</div>
                        <div class="div-table-cell" style="width: 16%">备注</div>
                    </div>
                    <div class="div-table-row" v-for="(AP, index) in item.DetailList" :key="index">
                        <div class="div-table-cell" style="width: 16%">{{ AP.APCode }}</div>
                        <div class="div-table-cell" style="width: 18%">{{ AP.GoodName }}</div>
                        <div class="div-table-cell" style="width: 20%">适用:{{ AP.AutoSerise }}</div>
                        <div class="div-table-cell" style="width: 6%">{{ AP.Count }}</div>
                        <div class="div-table-cell" style="width: 6%">{{ AP.Unit }}</div>
                        <div class="div-table-cell" style="width: 9%">{{ AP.MarketPrice }}</div>
                        <div class="div-table-cell" style="width: 9%">{{ (AP.Count * AP.MarketPrice).toFixed(2) }}</div>
                        <div class="div-table-cell" style="width: 16%">{{ AP.Remark }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 16%"></div>
                        <div class="div-table-cell" style="width: 18%"></div>
                        <div class="div-table-cell pall-count" style="width: 20%">总数量 &nbsp;</div>
                        <div class="div-table-cell" style="width: 6%">{{ allNum }}</div>
                        <div class="div-table-cell" style="width: 6%"></div>
                        <div class="div-table-cell pall-count" style="width: 9%">总价 &nbsp;</div>
                        <div class="div-table-cell" style="width: 9%">{{ allPrice.toFixed(2) }}</div>
                        <div class="div-table-cell" style="width: 16%"></div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 16%">客户要求</div>
                        <div class="div-table-cell" style="width: 84%">{{ item.Remark }}</div>
                    </div>
                </div>
                <!--    脚注    -->
                <div class="order-remark" v-show="(remarkConfig.Result && !remarkEdit)|| orderData.IsHaveTitleSet" style="margin-bottom: 20px">{{ orderData.IsHaveTitleSet ? orderData.OrderTitle : remarkConfig.RValue }}</div>
                <div class="order-setContent" v-show="remarkEdit">
                    <el-input type="textarea" resize="auto" rows="3" v-model="remarkConfig.RValue"></el-input>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-left-ctn">
                <!--   标题   -->
                <el-button class="btn-primary" @click="isEditTitle = true" v-if="titleConfig == null ? false : titleConfig.Result && !isEditTitle&& !orderData.IsHaveTitleSet">编辑标题</el-button>
                <el-button class="btn-primary" @click="submitTitleConfig()" v-if="isEditTitle">保存标题</el-button>
                <el-button class="btn-primary" @click="editConfig(1)" v-show="remarkConfig.Result && !remarkEdit&& !orderData.IsHaveTitleSet">编辑脚注</el-button>
                <el-button class="btn-primary" @click="saveConfig(1)" v-show="remarkEdit">保存脚注</el-button>
                <el-button class="btn-primary" @click="editConfig(2)" v-show="openTimeConfig.Result && !openTimeEdit">设置开单时间</el-button>
                <el-button class="btn-primary" @click="saveConfig(2)" v-show="openTimeEdit">保存开单时间</el-button>
            </div>
            <div class="btn-right-ctn">
                <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" @click="printedRecord" v-print="'#printContent'" v-else>打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
// import html2canvas from "html2canvas";
export default {
    name: '',
    components: {},
    props: ['printIds'],
    data() {
        return {
            loading: false,
            isEditTitle: false, //编辑标题
            titleConfig: {}, //标题配置
            remarkConfig: {},
            remarkEdit: false,
            openTimeConfig: {},
            openTimeEdit: false,
            allPrice: 0,
            allNum: 0,
            printList: [],
            company: this.$util.getLocalStorage('userMsg').EntpName,
            isPrint: false,
            isPreview: false,
            isDefaultSet: false,
            orderData: {},
        };
    },
    created() {
        this.getConfigByCodes();
    },
    mounted() {
        this.getBJOrder();
    },
    methods: {
        getConfigByCodes() {
            let codes = ['dyyl', 'syllqdysz', 'dybjsm', 'dybjsj', 'dybjbt'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'dyyl':
                                this.isPreview = result;
                                break;
                            case 'syllqdysz':
                                this.isDefaultSet = result;
                                break;
                            case 'dybjsm':
                                this.remarkConfig = data[i];
                                break;
                            case 'dybjsj':
                                this.openTimeConfig = data[i];
                                break;
                            case 'dybjbt':
                                this.titleConfig = data[i];
                                break;
                        }
                    }
                }
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let strBodyStyle = `<style>
.order-detail {
  width: 742px;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 10px;
  margin-right: 10px;
  padding: 15px 0;
  color: #000;
}
.order-setContent {
  margin-bottom: 20px;
}
.company {
  padding: 20px 0;
  color: #000;
}
.print-title {
     width: 762px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #000;
}
.print-table-main {
  width: 762px;
  margin-left: 1px;
  margin-bottom: 20px;
  font-size: 12px;
  }
  .div-table-row {
    display: flex;
    border-color: black;
    border-left: 1px solid #000;
  }
  .div-table-cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: auto;
    line-height: 24px;
    padding-left: 10px;
    border-top: 1px solid #000;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
    color: #000;
  }
  
</style>`;

                let strPrintHtml = strBodyStyle + '<body>' + document.getElementById('printContent').innerHTML + '</body>';
                if (this.printList[0].DetailList.length <= 60) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', ''); // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                } else {
                    LODOP.SET_PRINT_PAGESIZE(0, '210mm', '286mm', '');
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                    LODOP.NEWPAGEA();
                }
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord(
                    {
                        OrderId: this.printIds[0],
                        Type: 12
                    },
                    true
                )
                .then(res => {
                    this.isPrint = true;
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        editConfig(type) {
            if (type == 1) {
                this.remarkEdit = true;
            } else if (type == 2) {
                this.openTimeEdit = true;
            }
        },
        saveConfig(type) {
            if (type == 1) {
                if (!this.remarkConfig.RValue || !this.remarkConfig.RValue.trim()) {
                    this.$message.error('请输入脚注');
                    return;
                }
                this.remarkEdit = false;
                this.$util.setSysConfigValue(this.remarkConfig.ConfigId, this.remarkConfig.RValue);
            } else if (type == 2) {
                this.openTimeEdit = false;
            }
        },
        //提交打印标题
        submitTitleConfig() {
            this.isEditTitle = false;
            this.$util.setSysConfigValue(this.titleConfig.ConfigId, this.titleConfig.RValue);
        },
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        getBJOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpQuotationOrder/GetEntpQuotationOrderPrint',
                    data: {
                        QuoteId: this.printIds[0]
                    },
                    hideLoading: true
                })
                .then(res => {
                    let _allNum = 0;
                    let _allPrice = 0;
                    let data = res.data;
                    this.orderData = res.data;
                    let DetailList = data.DetailList;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allPrice += DetailList[i].Count * DetailList[i].MarketPrice;
                    }
                    this.allNum = _allNum;
                    this.allPrice = _allPrice;
                    this.printList.push(res.data);
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.order-detail {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding: 15px 0;
    color: #000;
}
.order-setContent {
    margin-bottom: 20px;
}
.company {
    padding: 20px 0;
    color: #000;
}
.print-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
}
.dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.print-table-main {
    // width: 792px;
    margin-left: 1px;
    margin-bottom: 20px;
    font-size: 12px;
    .div-table-row {
        border-color: black;
    }
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 24px;
        padding-left: 10px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }
    .pall-count {
        text-align: right;
    }
}
</style>
